import { render, staticRenderFns } from "./CloverItem--Card.vue?vue&type=template&id=55910696&lang=pug&"
import script from "./CloverItem--Card.vue?vue&type=script&lang=js&"
export * from "./CloverItem--Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports